import {
  Dropdown,
  leadsPartialUpdateMutation,
  PaginatedDropdownList,
  ReasonsListListData,
  reasonsListListInfiniteOptions
} from '@crm/api'
import { InfiniteSelect } from '@crm/components'
import { listTransformResults } from '@crm/utils'
import { useLocales } from '@shared/locales'
import { showApiErrors } from '@shared/utils'
import { useMutation } from '@tanstack/react-query'
import { Button, Flex, Form, Modal } from 'antd'

type Props = {
  open: boolean
  leadId?: number
  onConfirm: () => void
  onCancel: () => void
}

export const RefusalReasonModal = ({
  open,
  leadId,
  onConfirm,
  onCancel
}: Props) => {
  const { t } = useLocales()
  const [form] = Form.useForm()

  const { mutate, isPending } = useMutation({
    ...leadsPartialUpdateMutation(),
    onError: (e) => showApiErrors(e),
    onSuccess: () => {
      form.resetFields()
      onConfirm()
    }
  })

  const onOk = async () => {
    const values = await form.validateFields()
    mutate({
      path: { id: Number(leadId) },
      body: { reason: values.reason }
    })
  }

  const handleCancel = () => {
    form.resetFields()
    onCancel()
  }

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      title={t('nomenclature.requires_refusal_reason')}
      destroyOnHidden
      footer={
        <Flex justify="end" gap={8}>
          <Button disabled={isPending} onClick={handleCancel}>
            {t('buttons.cancel')}
          </Button>
          <Button type="primary" loading={isPending} onClick={onOk}>
            {t('buttons.save')}
          </Button>
        </Flex>
      }
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="reason"
          label={t('contacts.reason')}
          rules={[{ required: true }]}
        >
          <InfiniteSelect<ReasonsListListData, PaginatedDropdownList, Dropdown>
            getQueryFunction={reasonsListListInfiniteOptions}
            getOptions={({ options }) => listTransformResults(options)}
            popupMatchSelectWidth
          />
        </Form.Item>
      </Form>
    </Modal>
  )
}
